<template>
  <div class="red-text">
    {{time}}
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapActions } from 'vuex';
export default {
  name: 'Timer',
  props: {
    mathDate: String
  },
  data() {
    return {
      time: null,
      timeLoop: null
    }
  },
  watch: {
    mathDate: {
      immediate: true,
      handler (val) {
        this.RunTime()
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeLoop);
    this.SetDailyCloseTimer(null)
  },
  methods: {
    ...mapActions(['SetDailyCloseTimer']),
    RunTime () {
      this.timeLoop = setInterval(() => {
          let now = moment(moment.tz('Asia/Hong_Kong').format("YYYY-MM-DD H:mm:ss")).valueOf()
          let Time = moment(new Date(this.mathDate)).valueOf();
          let subTime = moment.tz(Time - now, "Africa/Abidjan")
          this.time = moment(subTime).valueOf() > 0 
            ? this.timeText(moment(subTime.subtract(1, 'seconds')))
            : `00:00:00`
          this.SetDailyCloseTimer(this.time)
      }, 1000)
    },
    timeText (date) {
      const time = (val) => {
        return val < 10 ? `0${val}` : val
      }
      let rtime = ''
      const d = date.get('date')
      date.get('hours') > 0 ? rtime += `${time(date.get('hours'))}:` : ''
      rtime += `${time(date.get('minutes'))}`
      rtime += `:${time(date.get('seconds'))}`
      return rtime
    }
  }
}
</script>